var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 42.75c-.703 0-1.125-.422-1.125-1.125v-24.75c0-.563.422-1.125 1.125-1.125.563 0 1.125.563 1.125 1.125v24.75c0 .703-.563 1.125-1.125 1.125zm0 6.75c1.125 0 2.25 1.125 2.25 2.25 0 1.266-1.125 2.25-2.25 2.25a2.221 2.221 0 01-2.25-2.25c0-1.125.984-2.25 2.25-2.25zM36 0c19.828 0 36 16.172 36 36 0 19.969-16.172 36-36 36A35.89 35.89 0 010 36C0 16.172 16.031 0 36 0zm0 69.75c18.563 0 33.75-15.047 33.75-33.75C69.75 17.437 54.562 2.25 36 2.25 17.297 2.25 2.25 17.438 2.25 36A33.669 33.669 0 0036 69.75z",
    fill: "#DD4267"
  })));
}
export default SvgExclamationCircleRed;